import { emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { ActiveProgram, CompletedProgram } from '../../ProgramStore/Types';
import CompletedSessionCount from './CompletedSesssionCount';

interface Props {
  programDetail: ActiveProgram | CompletedProgram;
}

const ProgramSessionsDetails: React.FC<Props> = ({ programDetail }) => {
  return programDetail.productDetails
    .map((pd) => {
      switch (pd.payload.kind) {
        case 'coaching':
          return (
            <CompletedSessionCount
              title="Sessions Completed"
              completedSessionCount={pd.payload.pastSessionsCount}
            />
          );
        case 'program':
        case 'program-sequence':
        case 'group-coaching':
          return emptyFragment();
      }
    })
    .getOrElse(() => emptyFragment());
};

export default observer(ProgramSessionsDetails);
